import { Switch } from '@/components/shadcn/switch'
import { Label } from '@/components/shadcn/label'

export function CompactViewToggle({
  compactMode,
  setCompactMode,
}: {
  compactMode: boolean
  setCompactMode: (compactMode: boolean) => void
}) {
  return (
    // <div className="absolute right-[50%] top-0 z-[10] flex translate-x-1/2 translate-y-[calc(-100%+1px)] items-center gap-x-1 rounded-t-md border-x-[0.5px] border-t-[0.5px] bg-offwhite px-1 py-0.5">
    // <div className="absolute right-[8px] top-5 z-[10] flex translate-y-[calc(-100%+1px)] items-center gap-x-1 rounded-t-md border-x-[0.5px] border-t-[0.5px] bg-offwhite px-1 py-0.5">
    <div className="absolute right-[8px] top-5 z-[10] flex translate-y-[calc(-100%)] items-center gap-x-1 px-1 py-0.5">
      <Switch
        className="h-4 w-7 data-[state=checked]:bg-input"
        thumbClassName="h-3 w-3 data-[state=checked]:translate-x-3"
        checked={compactMode}
        onCheckedChange={setCompactMode}
      />
      <Label
        onClick={() => setCompactMode(!compactMode)}
        // className="cursor-pointer text-xs font-light text-muted-foreground"
        className="cursor-pointer text-xs font-light text-foreground/70"
      >
        Compact View
      </Label>
    </div>
  )
}
